<template>
  <el-alert
    class="material-notif"
    :title="message"
    type="info"
    effect="dark"
  />
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    }
  }
};
</script>

<style scoped>
.material-notif {
  position: absolute;
  left: 16px;
  bottom: 16px;
  width: calc(100% - 32px);
  min-width: fit-content;
  white-space: nowrap;
  background: #7f8288;
  color: #ffffff;
  border: 1px solid #d1d4d7;
  height: 40px;
  padding: 0px;
}
.material-notif >>> .el-alert__content {
  margin-right: 12px;
  font-size: 14px;
}
.material-notif >>> .el-alert__title {
  font-size: 14px;
}
.material-notif >>> .el-alert__closebtn {
  font-size: 24px;
  right: 8px;
  top: 8px;
}
</style>
